.identity-iframe-loading{align-items:center;display:flex;flex-direction:column;height:calc(100% - 7px);justify-content:center;width:100%}.identity-iframe{height:calc(100% - 7px);width:100%;border:none}
/*# sourceMappingURL=identity-iframe.component-7O76R3BC.css.map */
